import React, { useState, useEffect, useRef } from "react";
import "./PedidosPendientes.css";
import {
  getValidatedAndProcessingOrders,
  getInvoiceLines, // ← add this
  getOrderLines,
} from "../../services/Carrito/getOrders&Invoices";
import { setOrderAsInvoiced, closeOrder } from "../../services/posOrders";
import {
  addPaymentToInvoice,
  createInvoiceFromOrder,
  invoiceBanKAccountUpdate,
  payInvoice,
  validateInvoice,
} from "../../services/posInvoices";
import {
  closeShipment,
  createOrderShipment,
  getShipmentsBySocid,
  validateShipment,
} from "../../services/Shipments/shipmentManagement";
import { useLocation } from "react-router-dom";


const PedidosEntregar = ({ setPedidosCount, pedidos, refreshOrders, isLoading }) => {
  //const location = useLocation();
  //const { nombre } = location.state || {};
  //const [pedidos, setPedidos] = useState([]);
  const [isLoadingLines, setIsLoadingLines] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showProductos, setShowProductos] = useState(null); // Order id for which details are shown
  const [orderLines, setOrderLines] = useState([]);
  // New states for processing and notification
  const [processingOrderId, setProcessingOrderId] = useState(null);
  const [orderClosedMessage, setOrderClosedMessage] = useState(null);
  
  // Ref para hacer scroll hacia la tabla de productos
  const productosTableRef = useRef(null);
  
  localStorage.removeItem("carritoActual");
  let shipmentType = "1"; // default

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10; // Display 10 orders per page

  /*
  useEffect(() => {
    // Establecer el valor de shipmentType antes de realizar la llamada
    switch (nombre) {
      case "ASEIC":
        shipmentType = "1";
        break;
      case "AEMTEC":
        shipmentType = "2";
        break;
      case "AESETEC":
        shipmentType = "4";
        break;
      case "ADESC":
        shipmentType = "6";
        break;
      case "Pablo":
        shipmentType = "3";
        break;
      case "Andres":
        shipmentType = "5";
        break;
      default:
        shipmentType = "1";
    }

*/
  
    // Llamar a fetchOrders después de establecer shipmentType
    //fetchOrders();
 // }, [nombre]);

  // Extracted fetchOrders so we can refresh the table later.
  /*const fetchOrders = async () => {
    setIsLoadingOrders(true);
    try {
      const allOrders = await getValidatedAndProcessingOrders(shipmentType.toString());
      const filteredOrders = allOrders.filter(order => {
        if (order.warehouse_id === null) {
          // Si warehouse_id es null, solo mostrar a Pablo (3) o Andrés (5)
          return shipmentType === "3" || shipmentType === "5";
        }
        // Si no es null, mostrar solo los que coincidan con shipmentType
        return order.warehouse_id === shipmentType;
      });
      setPedidos(filteredOrders);
      setPedidosCount(filteredOrders.length);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setIsLoadingOrders(false);
    }
  };
*/

  // Fetch orders on component mount.
 // useEffect(() => {
  //  fetchOrders();
 // }, []);

  // Filter orders by search term
  const filteredPedidos = pedidos.filter(
    (pedido) =>
      pedido.ref.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
      pedido.name.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
      pedido.carne.toString().toLowerCase().includes(searchTerm.toLowerCase()) // Agregado búsqueda por carné
  );

  // Pagination: determine the orders to display on current page.
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredPedidos.slice(
    indexOfFirstOrder,
    indexOfLastOrder
  );

  const nextPage = () => {
    if (currentPage < Math.ceil(filteredPedidos.length / ordersPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleVer = async (pedidoId, payment_type, type) => {
    if (showProductos === pedidoId) {
      // Closing — just hide, don't touch localStorage
      setShowProductos(null);
      setOrderLines([]);
    } else {
      // Opening — save payment type immediately
      localStorage.setItem("pedidoEntregarAsociaTipoDePago", payment_type);
      setShowProductos(pedidoId);
      setIsLoadingLines(true);
      try {
        let lines;
        if (type === "invoices") {
          lines = await getInvoiceLines(pedidoId);
        } else {
          lines = await getOrderLines(pedidoId);
        }
        setOrderLines(lines);
        setIsLoadingLines(false);

        setTimeout(() => {
          if (productosTableRef.current) {
            productosTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);

      } catch (error) {
        console.error("Error fetching lines:", error);
        setIsLoadingLines(false);
      }
    }
  };
  const handleEntregar = async (pedidoId, socid, mode_reglement_id, type) => {
    if (processingOrderId !== null) return;
    setProcessingOrderId(pedidoId);

    // Resolve the correct mode_reglement_id from payment_type stored in localStorage
    const paymentType = localStorage.getItem("pedidoEntregarAsociaTipoDePago");
    let resolvedModeReglementId;
    if (paymentType === "LIQ") {
      resolvedModeReglementId = 4;
    } else if (paymentType === "SINPE") {
      resolvedModeReglementId = 106; // ← use 106 to match invoiceBanKAccountUpdate
    } else if (paymentType === "CB") {
      resolvedModeReglementId = 6;
    } else {
      resolvedModeReglementId = mode_reglement_id; // fallback to stored value
    }

    try {
      if (type === "invoices") {
        const bankUpdateResult = await invoiceBanKAccountUpdate(parseInt(pedidoId), resolvedModeReglementId);
        if (!bankUpdateResult) throw new Error("Error al actualizar cuenta bancaria");

        const paymentResult = await addPaymentToInvoice(parseInt(pedidoId));
        if (!paymentResult) throw new Error("Error al agregar pago");

      } else {
        const invoiceId = await createInvoiceFromOrder(parseInt(pedidoId));
        if (!invoiceId?.id) throw new Error("Error al crear la factura");

        const validationResult = await validateInvoice(parseInt(invoiceId.id));
        if (!validationResult) throw new Error("Error al validar la factura");

        const bankUpdateResult = await invoiceBanKAccountUpdate(parseInt(invoiceId.id), resolvedModeReglementId);
        if (!bankUpdateResult) throw new Error("Error al actualizar cuenta bancaria");

        const paymentResult = await addPaymentToInvoice(parseInt(invoiceId.id));
        if (!paymentResult) throw new Error("Error al agregar pago");

        const orderInvoiced = await setOrderAsInvoiced(pedidoId);
        if (!orderInvoiced) throw new Error("Error al marcar orden como facturada");

        const orderClosed = await closeOrder(pedidoId);
        if (!orderClosed) throw new Error("Error al cerrar la orden");
      }

      try {
        const shipment = await getShipmentsBySocid(socid, pedidoId);
        if (shipment) {
          await closeShipment(parseInt(shipment));
        } else {
          console.warn("No se encontró envío para esta orden, continuando...");
        }
      } catch (shipmentError) {
        console.warn("Error al cerrar envío, continuando:", shipmentError.message);
        // Don't throw — invoice is already paid, just log the warning
      }

      setOrderClosedMessage("Orden cerrada");
      refreshOrders();

    } catch (error) {
      console.error("Error processing:", error);
      setOrderClosedMessage("Error: " + error.message); // ← show actual error
    }
  };

  return (
    <div className="pedidos-container">
      <div className="search-container">
        <h2 className="pedidos-heading">Pedidos por Entregar</h2>
        <p>
          Pedidos que estando o no pagados solamente tienen que ser entregados.
          Se encuentran listos.
        </p>
        <input
          type="text"
          placeholder="Buscar por ID, nombre o carné"
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {isLoading ? (
        <div className="loading">Cargando las órdenes... Por favor espere</div>
      ) : (
        <>
          {orderClosedMessage && (
            <div className="order-closed-message">{orderClosedMessage}</div>
          )}
          <table className="pedidos-table">
            <thead>
            <tr>
              <th className="pedidos-table-header">Ref</th>
              <th className="pedidos-table-header">Nombre</th>
              <th className="pedidos-table-header">Fecha</th>
              <th className="pedidos-table-header">Total</th>
              <th className="pedidos-table-header">Pago</th>
              <th className="pedidos-table-header">Acción</th>
            </tr>
            </thead>
            <tbody>
            {currentOrders.map((pedido) => (
                <tr key={pedido.id} className="pedidos-table-row">
                  <td className="pedidos-table-cell">{pedido.ref}</td>
                  <td className="pedidos-table-cell">{pedido.name}</td>
                  <td className="pedidos-table-cell">{pedido.date_creation}</td>
                  <td className="pedidos-table-cell">
                    {new Intl.NumberFormat("es-CR", {
                      style: "currency",
                      currency: "CRC",
                      maximumFractionDigits: 0,
                    }).format(pedido.total)}
                  </td>
                  <td className="pedidos-table-cell">{pedido.payment_type}</td>
                  <td className="pedidos-table-cell">
                    <button
                        className="pedidos-view-button"
                        onClick={() => handleVer(pedido.id, pedido.payment_type, pedido.type)}
                    >
                      Ver
                    </button>
                  </td>
                </tr>
            ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className="pagination-controls">
            <button onClick={prevPage} disabled={currentPage === 1}>
              Anterior
            </button>
            <span>
              Página {currentPage} de{" "}
              {Math.ceil(filteredPedidos.length / ordersPerPage)}
            </span>
            <button
                onClick={nextPage}
                disabled={
                    currentPage ===
                    Math.ceil(filteredPedidos.length / ordersPerPage)
                }
            >
              Siguiente
            </button>
          </div>
        </>
      )}

      {showProductos !== null && (
          <div className="productos-table-container" ref={productosTableRef}>
            {isLoadingLines ? (
                <p>Cargando los detalles de la órden</p>
          ) : (
            pedidos
              .filter((pedido) => pedido.id === showProductos)
              .map((pedido) => (
                <div key={pedido.id} className="productos-table">
                  <h3>Pedido ID: {pedido.ref}</h3>
                  {orderLines.length > 0 ? (
                    <table className="productos-table">
                      <thead>
                        <tr>
                          <th>Código artículo</th>
                          <th>Artículo</th>
                          <th>Cantidad</th>
                          <th>Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderLines.map((line, idx) => {
                          const subtotal = line.qty * line.subprice;
                          return (
                            <tr key={idx}>
                              <td>{line.product_ref}</td>
                              <td>{line.product_label}</td>
                              <td>{line.qty}</td>
                              <td>{`₡${subtotal.toFixed(0)}`}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <p>No hay líneas de orden para este pedido.</p>
                  )}
                  <div className="productos-buttons">
                    <button
                        className="pedidos-view-button"
                        onClick={() => handleEntregar(pedido.id, pedido.socid, pedido.mode_reglement_id, pedido.type)}
                        disabled={processingOrderId === pedido.id}
                    >
                      {processingOrderId === pedido.id ? "Procesando..." : "Entregar"}
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
      )}
    </div>
  );
};

export default PedidosEntregar;